(() => {
  function init() {
    const product = document.querySelector('#main-product');
    if (!product || product.dataset.uxReady) return;
    product.dataset.uxReady = 'true';
    const bar = document.querySelector('[data-product-bar]');
    if (!bar) return;
    const action = bar.querySelector('[data-bar-action]');
    const price = bar.querySelector('[data-bar-price]');
    const options = bar.querySelector('[data-bar-options]');
    let choseOptions = new URLSearchParams(location.search).has('variant');
    let updatingVariant = false;
    let scheduled = false;
    const setAttribute = (el, name, value) => {
      if (el.getAttribute(name) !== value) el.setAttribute(name, value);
    };
    function update() {
      scheduled = false;
      const form = product.querySelector('.f8pr-buy-button');
      const button = form?.querySelector('button[type="submit"]');
      if (!form || !button) { bar.hidden = true; return; }
      const busy = form.classList.contains('processing') || updatingVariant;
      setAttribute(form, 'aria-busy', String(busy));
      setAttribute(button, 'aria-busy', String(busy));
      const stock = product.querySelector('.f8pr-stock');
      if (stock) { setAttribute(stock, 'role', 'status'); setAttribute(stock, 'aria-live', 'polite'); }
      const sourcePrice = product.querySelector('.f8pr-price');
      if (sourcePrice && price.innerHTML !== sourcePrice.innerHTML) price.innerHTML = sourcePrice.innerHTML;
      const choices = product.querySelector('.f8pr-variant-selection');
      choices?.querySelectorAll('input.disabled').forEach(input => setAttribute(input, 'aria-description', product.dataset.unavailableLabel));
      const hasChoices = !!choices && Array.from(choices.querySelectorAll('label,select')).some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const visibleLabel = input => Array.from(input.labels || []).find(label => label.getClientRects().length && getComputedStyle(label).visibility !== 'hidden');
      const selected = choices ? Array.from(choices.querySelectorAll('input[type="radio"]:checked')).map(input => visibleLabel(input)?.textContent.trim()).filter(Boolean) : [];
      const selectValues = choices ? Array.from(choices.querySelectorAll('select')).filter(select => select.getClientRects().length && getComputedStyle(select).visibility !== 'hidden').map(select => select.selectedOptions[0]?.textContent.trim()).filter(Boolean) : [];
      const selectedText = [...selected, ...selectValues].join(' / ');
      if (options.textContent !== selectedText) options.textContent = selectedText;
      const needsChoice = hasChoices && !choseOptions && !button.disabled;
      const label = needsChoice ? product.dataset.chooseOptions : button.textContent.trim();
      if (action.textContent !== label) action.textContent = label;
      action.disabled = button.disabled || busy;
      setAttribute(action, 'aria-busy', String(busy));
      const rect = button.getBoundingClientRect();
      const visible = rect.top >= 0 && rect.bottom <= innerHeight;
      const blocked = document.documentElement.matches('.m6pn-open,.m2a,.search-full,.search-full-mode,.with-fancybox,.fancybox-active,.popup-open') || document.body.matches('.m6pn-open,.fancybox-active,.popup-open');
      bar.hidden = !matchMedia('(max-width:760px)').matches || visible || blocked;
      document.body.classList.toggle('mymasha-bar-visible', !bar.hidden);
    }
    function schedule() {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    }
    product.addEventListener('change', event => {
      if (event.target.closest('.f8pr-variant-selection')) { choseOptions = true; updatingVariant = true; }
      schedule();
    });
    product.addEventListener('submit', schedule);
    product.addEventListener('click', async event => {
      const copyButton = event.target.closest('[data-offer-copy]');
      if (!copyButton) return;
      const offer = copyButton.closest('.mymasha-product-offer');
      const feedback = offer.querySelector('.mymasha-offer-feedback');
      try {
        await navigator.clipboard.writeText(copyButton.dataset.offerCopy);
        copyButton.textContent = offer.dataset.copiedLabel;
        feedback.textContent = offer.dataset.copySuccess;
      } catch {
        const range = document.createRange();
        range.selectNodeContents(offer.querySelector('code'));
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        feedback.textContent = offer.dataset.copyFailure;
      }
    });
    addEventListener('themeVariantUpdateFailed', () => { updatingVariant = false; schedule(); });
    addEventListener('themeVariantUpdated', () => { updatingVariant = false; schedule(); init(); });
    action.addEventListener('click', () => {
      const form = product.querySelector('.f8pr-buy-button');
      const button = form?.querySelector('button[type="submit"]');
      if (!button || button.disabled || updatingVariant || form.classList.contains('processing')) return;
      const choices = product.querySelector('.f8pr-variant-selection');
      const hasChoices = !!choices && Array.from(choices.querySelectorAll('label,select')).some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      if (hasChoices && !choseOptions) {
        choices.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
        const input = choices.querySelector('input[type="radio"]:checked,select,input[type="radio"]');
        input?.focus({preventScroll:true});
        return;
      }
      button.click();
    });
    new MutationObserver(schedule).observe(product, {subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled','value']});
    new MutationObserver(schedule).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
    new MutationObserver(schedule).observe(document.body, {attributes:true,attributeFilter:['class']});
    new MutationObserver(() => {
      document.querySelectorAll('.fancybox__container button[title]').forEach(button => setAttribute(button, 'aria-label', button.title));
      schedule();
    }).observe(document.body, {childList:true});
    addEventListener('scroll', schedule, {passive:true});
    addEventListener('resize', schedule, {passive:true});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  function reviewTarget() { return document.querySelector('.AirReviews-Blocks__Summary'); }
  function syncRatings() {
    const target = reviewTarget();
    if (!target) return;
    const anchor = target.closest('.AirReviews-Widget__V2') || target;
    anchor.id = 'mm-product-reviews';
    const count = parseInt(target.querySelector('.AirReviews-Blocks--ReviewCount__Text span')?.textContent || '0', 10);
    const rating = target.querySelector('.AirReviews-Blocks--RateCount')?.textContent.trim();
    document.querySelectorAll('[data-mm-social]').forEach(bar => {
      const text = count > 0 && rating ? rating + ' / 5 · ' + count + ' ' + bar.dataset.reviewWord : bar.dataset.empty;
      const output = bar.querySelector('[data-mm-rating]');
      if (output.textContent !== text) output.textContent = text;
      const fill=bar.querySelector('[data-mm-stars-fill]');const width=count>0?Math.min(100,Math.max(0,parseFloat(rating)/5*100))+'%':'0%';if(fill&&fill.style.width!==width)fill.style.width=width;
    });
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; syncRatings(); });
  }).observe(document.body, {childList:true,subtree:true});
  syncRatings();
  document.addEventListener('click', async event => {
    const bar = event.target.closest('[data-mm-social]');
    if (!bar) return;
    const toggle = event.target.closest('[data-mm-toggle]');
    if (toggle) { const menu=bar.querySelector('.mm-share-menu'); menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden));return; }
    if (event.target.closest('[data-mm-write],[data-mm-reviews]')) {
      event.preventDefault();
      const target = reviewTarget();
      if (!target) return;
      const write = !!event.target.closest('[data-mm-write]');
      const destination = write ? target.querySelector('.AirReviews-Blocks--Actions') || target : target;
      destination.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      if (write) {
        const input = destination.querySelector('input[type="radio"]');
        input?.focus({preventScroll:true});
      }
    }
    if (event.target.closest('[data-mm-copy],[data-mm-share]')) {
      const url = new URL(document.querySelector('link[rel="canonical"]').href);
      const variant = new URL(location.href).searchParams.get('variant');
      if (variant) url.searchParams.set('variant',variant);
      const status = bar.querySelector('[data-mm-status]');
      if (event.target.closest('[data-mm-share]') && navigator.share) {
        try { await navigator.share({title:document.querySelector('.mymasha-product-title').textContent,url:url.href}); }
        catch (error) { if (error.name !== 'AbortError') bar.querySelector('[data-mm-copy]').focus(); }
        return;
      }
      try { await navigator.clipboard.writeText(url.href); status.textContent = status.dataset.copied; }
      catch { const input=bar.querySelector('.mm-share-fallback');input.hidden=false;input.value=url.href;input.select();status.textContent=status.dataset.select; }
    }
  });
})();

document.addEventListener('click', event => {
  document.querySelectorAll('.mm-share').forEach(share => {
    if (!share.contains(event.target)) { share.querySelector('.mm-share-menu').hidden=true;share.querySelector('[data-mm-toggle]').setAttribute('aria-expanded','false'); }
  });
});
document.addEventListener('keydown', event => {
  if(event.key!=='Escape')return;
  document.querySelectorAll('.mm-share-menu:not([hidden])').forEach(menu => {menu.hidden=true;const toggle=menu.parentElement.querySelector('[data-mm-toggle]');toggle.setAttribute('aria-expanded','false');toggle.focus();});
});

(() => {
  const bound = new WeakSet();
  let restoreOverflow;
  const refreshOffers = () => {
    const now = Date.now() / 1000;
    document.querySelectorAll('.mm-compact-offers').forEach(list => {
      const dialog = list.querySelector('.mm-offers-dialog');
      list.querySelectorAll('[data-offer-ends]').forEach(card => {
        const end = Number(card.dataset.offerEnds);
        if (end > 0 && now >= end) {
          if (card.contains(document.activeElement)) dialog.querySelector('[data-mm-offers-title]').focus();
          card.remove();
        }
      });
      const cards = Array.from(list.querySelectorAll('.mm-admin-offer'));
      const lead = cards[0];
      const trigger = list.querySelector('[data-mm-offers-open]');
      if (!lead) {
        if (dialog.open) dialog.close();
        list.hidden = true;
        return;
      }
      list.hidden = false;
      const benefit = list.querySelector('[data-mm-offers-benefit]');
      const hint = list.querySelector('[data-mm-offers-hint]');
      const count = list.querySelector('[data-mm-offers-count]');
      const heading = lead.dataset.offerHeading;
      const codeHint = lead.dataset.offerCode ? hint.dataset.codeLabel.replace('__CODE__', lead.dataset.offerCode) : hint.dataset.automaticLabel;
      const label = count.dataset.label.replace('__COUNT__', String(cards.length));
      if (benefit.textContent !== heading) benefit.textContent = heading;
      if (hint.textContent !== codeHint) hint.textContent = codeHint;
      if (count.textContent !== label) count.textContent = label;
      if (!bound.has(dialog)) {
        bound.add(dialog);
        dialog.addEventListener('close', () => {
          if (restoreOverflow !== undefined) {
            document.documentElement.style.overflow = restoreOverflow;
            restoreOverflow = undefined;
          }
          if (!list.hidden) trigger.focus({preventScroll:true});
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        });
      }
    });
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-mm-offers-open]');
    if (opener) {
      refreshOffers();
      const list = opener.closest('.mm-compact-offers');
      const dialog = list.querySelector('.mm-offers-dialog');
      if (list.hidden || dialog.open) return;
      restoreOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      dialog.querySelector('[data-mm-offers-title]').focus({preventScroll:true});
    }
    const closer = event.target.closest('[data-mm-offers-close]');
    if (closer) closer.closest('dialog').close();
  });
  refreshOffers();
  setInterval(refreshOffers, 30000);
  document.addEventListener('visibilitychange', refreshOffers);
  document.addEventListener('shopify:section:load', refreshOffers);
})();
